import { Globals } from '@bwoty-web/ui-kit';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import PriceMatrixContainer from './containers/PriceMatrixContainer';
import { createPriceMatrixStore } from './redux/store/priceMatrixStore';

const initialState = window.__INITIAL_STATE_IW_PRICE_MATRIX__;
delete window.__INITIAL_STATE_IW_PRICE_MATRIX__;

if (initialState) {
  const priceMatrixStore = createPriceMatrixStore(initialState);
  const { siteSettings } = initialState;

  const root = createRoot(document.getElementById('iw-price-matrix'));
  root.render(
    <Globals
      siteId={siteSettings?.siteId || 1}
      legacyMode={siteSettings?.legacyMode}
    >
      <Provider store={priceMatrixStore}>
        <PriceMatrixContainer />
      </Provider>
    </Globals>,
  );
}
